import React from 'react';
import styles from './StepCard.module.css';
import Button from './Button';
import IconCircle from './IconCircle';

const StepCard = ({ 
  stepNumber, 
  icon, 
  title, 
  description,
  titleWidth
}) => {
  return (
    <div className={styles.stepCard}>
      <div className={styles.stepButton}>
        <Button variant='step'>STEP {stepNumber}</Button>
      </div>

      <IconCircle icon={icon} />

      <div className={styles.content}>
        <h3 className={styles.title} style={{'--title-width': titleWidth }}>{title}</h3>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  );
};

export default StepCard;